"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createSvgIcon_1 = __importDefault(require("../createSvgIcon"));
exports.default = (0, createSvgIcon_1.default)(react_1.default.createElement("g", null,
    react_1.default.createElement("path", { d: "M11.25 0H8.25V1.5H11.25C12.4875 1.5 13.5 2.5125 13.5 3.75C13.5 4.9875 12.4875 6 11.25 6H8.25V7.5H11.25C13.32 7.5 15 5.82 15 3.75C15 1.68 13.32 0 11.25 0ZM6.75 6H3.75C2.5125 6 1.5 4.9875 1.5 3.75C1.5 2.5125 2.5125 1.5 3.75 1.5H6.75V0H3.75C1.68 0 0 1.68 0 3.75C0 5.82 1.68 7.5 3.75 7.5H6.75V6ZM4.5 3H10.5V4.5H4.5V3Z" })), 'Link');
//# sourceMappingURL=index.js.map